module.exports = __webpack_public_path__ + "static/media/englishIcon.f6f4a917.png";